<template>
  <div id="app">
    <router-view :key="key"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    key () {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
    }
  }
}
</script>

<style lang="scss">
  #app {
    min-width: 1280px;
    height: 100%;
  }
  .el-tooltip__popper.is-light {
    border: 1px solid #1d91f3;
    color: #1d91f3;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue